import { Injectable } from '@angular/core';
import { PlanCuentaService } from 'src/app/services/plancuenta.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public static USER_KEY: string = "_dsessionInfo";
  cuentas: any[] = [];
  vista: any = 0;
  tipo: any;
  constructor(    
    private cuentasService: PlanCuentaService,
  ) { }

  //   getCuentas() {
  //   this.cuentasService.buscar_cuenta().subscribe((response: any) => {
  //     this.cuentas = response.body.list;
  //   });
  // }
  // ngOnInit(): void {
  //   this.getCuentas
  // }
}